/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务2）。
 * 底部 CTA 区块（partnership_home.html 第 5023 行起）：静态内容。
 * 注意事项：静态文案取自 props.t（getConstants().CTA，i18next 六国翻译，含 {{fullName}} 插值）。
 */
import React from 'react';

export default function PartnerCta({ t }) {
  const c = t || {};
  return (
    <section className="cj-partner-cta" id="become-a-partner">
      <div className="cj-partner-dots" />
      <div className="cj-partner-shape" />
      <div className="cj-partner-glow" />

      <div className="cj-partner-container">
        <div className="cj-partner-eyebrow">{c.eyebrow}</div>
        <h2 className="cj-partner-title">{c.title}</h2>
        <p className="cj-partner-description">{c.desc}</p>
        <div className="cj-partner-buttons">
          {/* 260713163000（第8次补充 任务1.5）：因为需求要求与原页 partnership-join-btn(toAdd→/partnership-add.html) 一致，由 WhatsApp 改为 /partnership-add.html（同窗跳转）。 */}
          <a className="cj-partner-button cj-partner-button-primary" href="/partnership-add.html">
            {c.apply}
            <span className="cj-partner-arrow">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
